/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerGeneratedDocument } from './ScreenerGeneratedDocument';
import {
    ScreenerGeneratedDocumentFromJSON,
    ScreenerGeneratedDocumentFromJSONTyped,
    ScreenerGeneratedDocumentToJSON,
    ScreenerGeneratedDocumentToJSONTyped,
} from './ScreenerGeneratedDocument';
import type { ScreenerAdditionalDocument } from './ScreenerAdditionalDocument';
import {
    ScreenerAdditionalDocumentFromJSON,
    ScreenerAdditionalDocumentFromJSONTyped,
    ScreenerAdditionalDocumentToJSON,
    ScreenerAdditionalDocumentToJSONTyped,
} from './ScreenerAdditionalDocument';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface ExternalEhrDocuments
 */
export interface ExternalEhrDocuments {
    /**
     * 
     */
    generated_documents?: Array<ScreenerGeneratedDocument>;
    /**
     * 
     */
    screener_documents?: Array<Document>;
    /**
     * 
     */
    additional_documents?: Array<ScreenerAdditionalDocument>;
}

/**
 * Check if a given object implements the ExternalEhrDocuments interface.
 */
export function instanceOfExternalEhrDocuments(value: object): value is ExternalEhrDocuments {
    return true;
}

export function ExternalEhrDocumentsFromJSON(json: any): ExternalEhrDocuments {
    return ExternalEhrDocumentsFromJSONTyped(json, false);
}

export function ExternalEhrDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrDocuments {
    if (json == null) {
        return json;
    }
    return {
        
        'generated_documents': json['generated_documents'] == null ? undefined : ((json['generated_documents'] as Array<any>).map(ScreenerGeneratedDocumentFromJSON)),
        'screener_documents': json['screener_documents'] == null ? undefined : ((json['screener_documents'] as Array<any>).map(DocumentFromJSON)),
        'additional_documents': json['additional_documents'] == null ? undefined : ((json['additional_documents'] as Array<any>).map(ScreenerAdditionalDocumentFromJSON)),
    };
}

export function ExternalEhrDocumentsToJSON(json: any): ExternalEhrDocuments {
    return ExternalEhrDocumentsToJSONTyped(json, false);
}

export function ExternalEhrDocumentsToJSONTyped(value?: ExternalEhrDocuments | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generated_documents': value['generated_documents'] == null ? undefined : ((value['generated_documents'] as Array<any>).map(ScreenerGeneratedDocumentToJSON)),
        'screener_documents': value['screener_documents'] == null ? undefined : ((value['screener_documents'] as Array<any>).map(DocumentToJSON)),
        'additional_documents': value['additional_documents'] == null ? undefined : ((value['additional_documents'] as Array<any>).map(ScreenerAdditionalDocumentToJSON)),
    };
}

